// The ONE place a person's typed loyalty list (ART-197) is grouped and labelled, so the mobile contact card
// and the desktop CrewProfileModal cannot draw the Airlines/Hotels split two different ways. The server stores
// only `airline`/`hotel` rows; an unrecognised kind (or a nameless entry) is dropped here rather than rendered
// under a group that does not exist — the same "render the fact or nothing" rule the rest of these surfaces use.
import type { components } from "@cntrl/api-client";

export type LoyaltyProgram = components["schemas"]["LoyaltyProgram"];

/** The kind vocabulary, as `Picker`/`Select` options for the editor. Mirrors the server's `LoyaltyKinds`. */
export const LOYALTY_KINDS = [
  { value: "airline", label: "Airline" },
  { value: "hotel", label: "Hotel" },
] as const;

export type LoyaltyKind = (typeof LOYALTY_KINDS)[number]["value"];

export interface LoyaltyGroups {
  airlines: LoyaltyProgram[];
  hotels: LoyaltyProgram[];
}

/** Split the typed list into its two rendered groups, keeping only entries that actually name something. */
export function groupLoyalty(programs: readonly LoyaltyProgram[] | null | undefined): LoyaltyGroups {
  const airlines: LoyaltyProgram[] = [];
  const hotels: LoyaltyProgram[] = [];
  for (const p of programs ?? []) {
    if (!p || typeof p.name !== "string" || p.name.trim() === "") continue;
    if (p.kind === "airline") airlines.push(p);
    else if (p.kind === "hotel") hotels.push(p);
  }
  return { airlines, hotels };
}

/** One membership as `Name · Number`, or just the name when no number is recorded. */
export function loyaltyLabel(p: LoyaltyProgram): string {
  const name = (p.name ?? "").trim();
  const number = (p.number ?? "").trim();
  return number ? `${name} · ${number}` : name;
}
